import api from '../../plugins/api';

// GET /api/crm/vin-blacklist â ÑÐ¿Ð¸ÑÐ¾Ðº Ñ Ð¿Ð¾Ð¸ÑÐºÐ¾Ð¼ Ð¿Ð¾ VIN Ð¸ ÑÑÑÐ°Ð½Ð¸ÑÐ°Ð¼Ð¸. Ð¢Ð¾Ð»ÑÐºÐ¾ Ð°Ð´Ð¼Ð¸Ð½.
const getVinBlacklist = (params) => {
  return api.get('/api/crm/vin-blacklist', params);
};

export default getVinBlacklist;
